import { Typography } from '@/components/ui/typography'
import { useFormContext } from '@/lib/form-contexts'
import { Image, TextAlignStart } from 'lucide-react'
import PageAnnouncementBarLinkToggle from './PageAnnouncementBarLinkToggle'

const PREFIX = 'pages./about-us.blocks.main.0'
const aboutUs = (str) => `${PREFIX}.${str}`

const AboutUsPageForm = () => {
  const form = useFormContext()

  return (
    <div className="flex flex-col gap-y-6 mb-4">
      <PageAnnouncementBarLinkToggle pageKey="aboutUs" />

      <form.AppField name={aboutUs('is_enabled')}>
        {(field) => (
          <field.SwitchInput
            label="Show About Us Story"
            description="Turn this on to display your About Us image, headline, and paragraph."
          />
        )}
      </form.AppField>

      <form.AppField name={aboutUs('media.0')}>
        {(field) => (
          <field.MediaUploadInput
            className="max-w-xl"
            label={
              <Typography variant="emphasis" className="flex items-center gap-2">
                <Image className="size-5" /> About Us Image
              </Typography>
            }
            description="Shown as a circular image above your About Us text."
          />
        )}
      </form.AppField>

      <div className="flex flex-col gap-y-4">
        <Typography variant="emphasis" className="flex items-center gap-2">
          <TextAlignStart className="size-5" /> Story Content
        </Typography>

        <form.AppField name={aboutUs('props.title')}>
          {(field) => <field.TextInput label="Headline" placeholder="e.g. Our Story" />}
        </form.AppField>

        <form.AppField name={aboutUs('props.text')}>
          {(field) => (
            <field.TextareaInput
              label="Paragraph"
              placeholder="Share your story, your style, and what makes your flower shop special."
              rows={6}
            />
          )}
        </form.AppField>

        <Typography variant="supporting">
          * If image, headline, and paragraph are all blank, only your locations section will
          appear.
        </Typography>
      </div>
    </div>
  )
}

export default AboutUsPageForm
